<template>
  <div class="page pb-12 mb-12">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-account-outline</v-icon>
      أهلا بك
      <span class="secondary--text mr-1">{{ $auth.user() && $auth.user().name }}</span>
      <back-button />
    </h2>
    <hr class="my-5 header-divider" />

    <template v-if="can('others.statistics')">      
      <numeric-statistics
        :loading="loading"
        :statistics="numericStatistics"
      />

      <export-excel />

      <chart-statistics
        :loading="loading"
        :statistics="lastMonthStatistics"
      />

      <pages-table
        :loading="loading"
        :data="pagesData"
      />

      <p class="text-center mt-8 white pa-3 deep-orange--text">
        للمزيد من التقارير يمكن زيارة
        <a
          class="info--text"
          target="_blank"
          href="https://analytics.google.com/analytics/web/?pli=1#/report-home/a181402523w250644075p231872090"
        >Google Analytics</a>
      </p>
    </template>
  </div>
</template>


<script>
import NumericStatistics from './NumericStatistics';
import ChartStatistics from './ChartStatistics';
import PagesTable from './PagesTable';
import ExportExcel from './ExportExcel.vue';

export default {
  name: 'home',
  components: { NumericStatistics, ChartStatistics, PagesTable, ExportExcel },

  data: function () {
    return {
      loading: false,
      pagesData: {},
      numericStatistics: {},
      lastMonthStatistics: {},
    }
  },


  created() {
    this.fetchStatistics();
  },


  methods: {
    fetchStatistics() {
      this.loading = true;

      this.axios.get('/admin/statistics')
        .then((response) => {
          this.numericStatistics = response.data.numeric;
          this.lastMonthStatistics = response.data.last_month;
          this.pagesData = response.data.pages;
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب الإحصائيات',
            color: 'accent'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>
